import React from 'react';

const MinusIcon = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width={size}
    height={size}
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 12H4" />
  </svg>
);

export default MinusIcon;
